import React from 'react';
import { Outlet } from 'react-router-dom';

const KlassiCareLayout = () => {
  return (
    <div className="klassicare-layout">
      <Outlet />
    </div>
  );
};

export default KlassiCareLayout; 